import script from "./TransferAddressInputs.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferAddressInputs.vue?vue&type=script&setup=true&lang=js"

import "./TransferAddressInputs.vue?vue&type=style&index=0&id=2c952d98&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c952d98"]])

export default __exports__
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSlideTransition,QBtn,QIcon,QField});
